module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// ./~/fbjs/~/core-js/library/modules/$.add-to-unscopables.js
// module id = 501
// module chunks = 0